import { render, staticRenderFns } from "./MA338Mobile.vue?vue&type=template&id=08604639&scoped=true&"
import script from "./MA338Mobile.vue?vue&type=script&lang=js&"
export * from "./MA338Mobile.vue?vue&type=script&lang=js&"
import style0 from "./MA338Mobile.vue?vue&type=style&index=0&id=08604639&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08604639",
  null
  
)

export default component.exports